/* eslint-disable import/extensions */

// Services images will use standard URLs from zerlak.com

// Portfolio images will use themed Unsplash URLs per project or local assets
import ChandrikaImage from '../assets/images/Portfolio/Chandraka Electricles.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials images will use fallback/initials; no local imports

// TeamMembers images will use standard URLs from zerlak.com

// Local service images (used as reliable fallbacks)
import ServiceErp from '../assets/images/ZERLAK ERP.PNG';
import ServiceStoneCrusher from '../assets/images/Services/stonecrusher.jpg';
import ServiceDigitalMarketing from '../assets/images/Services/digital-marketing.jpg';
// Product images (HRM/CRM)
import ZerlakHRM from '../assets/images/ZERLAK HRM.PNG';
import ZerlakCRM from '../assets/images/ZERLAK CRM.PNG';
// Landing (Services) images replacements
import WebApplicationImage from '../assets/images/web application.png';
import MobileApplicationImage from '../assets/images/mobile application.png';
import UIUXImage from '../assets/images/uiux.png';
// New product images
import SparePartDistributorUI from '../assets/images/spare part distrubutor ui.png';
import MarbleTilesUI from '../assets/images/Marbel tails ui.png';
import StudyRoomLocal from '../assets/images/study room.png';

export const Services = [
  {
    title: 'Web Development',
  imageUrl: WebApplicationImage,
    animation: 'left',
  },
  {
    title: 'Mobile Development',
  imageUrl: MobileApplicationImage,
    animation: 'up',
  },
  {
    title: 'UI/UX Design',
  imageUrl: UIUXImage,
    animation: 'right',
  },
  {
    title: 'ERP Solutions',
  imageUrl: ServiceErp,
    animation: 'left',
  },
  {
    title: 'Stone Crusher Management',
    imageUrl: ServiceStoneCrusher,
    animation: 'up',
  },
  {
    title: 'Digital Marketing',
    imageUrl: ServiceDigitalMarketing,
    animation: 'right',
  },
];

export const Portfolios = [
  // Website projects
  {
    id: 'website-coffeesaaz',
    title: 'CoffeSaaz Project',
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1400&q=60',
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    description: 'A modern coffee e-commerce storefront for small roasters with product catalog, subscriptions, secure checkout, and CMS-powered content. Built mobile-first for fast browsing and conversions.',
    features: [
      'Product catalog with variants & filters',
      'Subscription ordering for recurring deliveries',
      'Secure checkout (Stripe/Razorpay)',
      'Order tracking and email notifications',
      'Blog/recipes via headless CMS',
      'Fully responsive with optimized images',
    ],
    techStack: ['React', 'Tailwind CSS', 'Node.js', 'Express', 'MongoDB', 'Stripe/Razorpay'],
    credit: '',
  },
  {
    id: 'website-chandrika-electricals',
    title: 'Chandrika Electricals',
    imageUrl: ChandrikaImage,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    description: 'Corporate site for an MSEDCL-licensed electrical contractor in Maharashtra. Highlights services (HT/LT installations, substation work, industrial electrification), statutory compliance, and quick enquiry for work orders.',
    features: [
      'Services: HT/LT installations, substation & transformer work',
      'Industrial & commercial electrification showcase',
      'Compliance badges: MSEDCL license, safety standards, QA',
      'Past projects gallery with scope and capacity (kVA/kW)',
      'Quick RFQ/contact with WhatsApp and Google Maps',
      'SEO-friendly pages for local discoverability',
    ],
    techStack: ['React', 'Tailwind CSS', 'EmailJS', 'Netlify/Cloud Hosting'],
    credit: '',
  },
  {
    id: 'website-innovativesoft',
    title: 'InnovativeSoft',
    imageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1400&q=60',
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    description: 'Software company site showcasing products, case studies, and careers with a simple content workflow.',
    features: [
      'Product and solutions pages',
      'Case studies with KPIs and outcomes',
      'Careers listings with application form',
      'Blog/announcements via headless CMS',
      'Analytics & basic lead tracking',
    ],
    techStack: ['React', 'Tailwind CSS', 'Contentful/Strapi', 'Vite/CRA'],
    credit: '',
  },

  // Mobile apps
  {
    id: 'mobile-kokan-xplore',
    title: 'Kokan Xplore App',
    imageUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1400&q=60',
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    description: 'Travel companion app for exploring the Konkan region with curated places, itineraries, and offline-friendly browsing.',
    features: [
      'Location-based listings and filters',
      'Offline caching for key content',
      'Itinerary builder and bookmarks',
      'Hotel/restaurant suggestions',
      'Ratings and reviews',
    ],
    techStack: ['React Native', 'Expo', 'REST API', 'SQLite/AsyncStorage'],
    credit: '',
  },
  {
    id: 'mobile-dating-app',
    title: 'Dating App',
    imageUrl: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1400&q=60',
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    description: 'Swipe-based dating application with profile verification, matching, and real-time chat.',
    features: [
      'Onboarding with OTP/email verification',
      'Profile creation with interests & photos',
      'Swipe/match and suggestions',
      'Real-time chat with typing indicators',
      'Push notifications and privacy controls',
    ],
    techStack: ['React Native', 'Firebase', 'WebSockets', 'Cloud Functions'],
    credit: '',
  },
  {
    id: 'mobile-hrm-app',
    title: 'HRM App',
    imageUrl: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1400&q=60',
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    description: 'Human Resource Management app for employees and managers to handle attendance, leave, approvals, and payroll insights on the go.',
    features: [
      'Attendance & geofenced check-in',
      'Leave requests and approvals',
      'Payslip viewer and policy docs',
      'Announcements & notifications',
      'Role-based access',
    ],
    techStack: ['React Native', 'Redux', 'REST API', 'Push Notifications'],
    credit: '',
  },
];

export const Products = [
  {
    id: 'product-stone-crusher',
    title: 'Stone Crusher',
    imageUrl: ServiceStoneCrusher,
    type: 'Product',
    responsibility: ['Product Design', 'Implementation', 'Support'],
    description: 'End-to-end Stone Crusher management with inventory, billing, weighbridge integration, and analytics.',
    features: [
      'Dispatch, billing & GST invoicing',
      'Weighbridge & loader integration',
      'Stock & production tracking',
      'Party ledger and receivables',
      'MIS reports & dashboards',
    ],
    techStack: ['React', 'Java', 'MySQL'],
    credit: '',
  },
  {
    id: 'product-erp-software',
    title: 'ERP Software',
    imageUrl: ServiceErp,
    type: 'Product',
    responsibility: ['Product Design', 'Implementation', 'Support'],
    description: 'Modular ERP covering Sales, Purchase, Inventory, Finance, HR, and Production for SMEs.',
    features: [
      'Sales & Purchase with approvals',
      'Inventory with batch/serial tracking',
      'Finance & GST compliance',
      'HR & Payroll modules',
      'BI dashboards & exports',
    ],
    techStack: ['React', 'Java', 'MySQL'],
    credit: '',
  },
  {
    id: 'product-hospital-management',
    title: 'Hospital Management',
    imageUrl: 'https://images.unsplash.com/photo-1584982751601-97dcc096659c?auto=format&fit=crop&w=1400&q=60',
    type: 'Product',
    responsibility: ['Product Design', 'Implementation', 'Support'],
    description: 'Hospital Management System with OPD/IPD, billing, pharmacy, lab, and doctor scheduling.',
    features: [
      'Patient registration & EMR',
      'OPD/IPD admissions & billing',
      'Pharmacy & lab integrations',
      'Doctor scheduling & queue mgmt',
      'Insurance & TPA support',
    ],
    techStack: ['React', 'Java', 'MySQL'],
    credit: '',
  },
  {
    id: 'product-study-room-management',
    title: 'Study Room Management',
  imageUrl: StudyRoomLocal,
    type: 'Product',
    responsibility: ['Product Design', 'Implementation', 'Support'],
    description: 'Desk/seat booking, membership billing, attendance, and analytics for study rooms and libraries.',
    features: [
      'Memberships & subscriptions',
      'Seat reservation & attendance',
      'Billing & payment tracking',
      'Notifications & reminders',
      'Reports & usage analytics',
    ],
    techStack: ['React', 'Express', 'PostgreSQL'],
    credit: '',
  },
  {
    id: 'product-spare-part-distributor-ui',
    title: 'Spare Part Distributor UI',
    imageUrl: SparePartDistributorUI,
    type: 'Product',
    responsibility: ['UI/UX', 'Front-end Development'],
    description: 'Catalog, ordering, and distributor dashboard UI for spare-part businesses with inventory and pricing views.',
    features: [
      'Product catalog with search and filters',
      'Distributor pricing tiers and availability',
      'Order cart and quick-quote flow',
      'Responsive dashboard components',
      'Downloadable specs and images',
    ],
    techStack: ['React', 'Tailwind CSS'],
    credit: '',
  },
  {
    id: 'product-marble-tiles-ui',
    title: 'Marble Tiles UI',
    imageUrl: MarbleTilesUI,
    type: 'Product',
    responsibility: ['UI/UX', 'Front-end Development'],
    description: 'Showcase and selection UI for marble and tile products with variant previews and inquiry flow.',
    features: [
      'Collection and variant galleries',
      'Filters by size, finish, and color',
      'Room preview/visualization ready',
      'Lead/inquiry capture',
      'SEO-friendly product pages',
    ],
    techStack: ['React', 'Tailwind CSS'],
    credit: '',
  },
  {
    id: 'product-hrm',
    title: 'HRM (In Progress)',
  imageUrl: ZerlakHRM,
    type: 'In Progress',
    responsibility: ['Product Design', 'Implementation', 'Support'],
    description: 'Human Resource Management solution covering attendance, leaves, payroll, and employee self-service.',
    features: [
      'Attendance & leave management',
      'Payroll processing & payslips',
      'Employee self-service portal',
      'Approvals & workflows',
      'Reports & compliance',
    ],
    techStack: ['React', 'Node.js', 'PostgreSQL'],
    credit: '',
  },
  {
    id: 'product-crm',
    title: 'CRM (In Progress)',
  imageUrl: ZerlakCRM,
    type: 'In Progress',
    responsibility: ['Product Design', 'Implementation', 'Support'],
    description: 'Customer Relationship Management for leads, deals, contacts, pipelines, and analytics.',
    features: [
      'Lead & contact management',
      'Deals & pipeline tracking',
      'Email/WhatsApp integration',
      'Tasks, reminders & notes',
      'Dashboards & analytics',
    ],
    techStack: ['React', 'Express', 'MySQL'],
    credit: '',
  },
];

export const Advantages = [
  [{
    title: 'Communicative',
    description: 'We communicate our project ideas and progress to make it clear.',
    imageUrl: Communicative,
  },
  {
    title: 'Management',
    description: 'We manage our project properly to make our project done well.',
    imageUrl: Management,
  }],
  [{
    title: 'Collaborative​',
    description: 'Our team are very collaborative to make our project done well.',
    imageUrl: Collaborative,
  },
  {
    title: 'Favorite',
    description: "We've did so many project and all of our client love it.",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  // Stone Crusher Management
  {
    id: 1,
    name: 'Rohan Sharma',
    company: 'Site Manager, Badra Crushers',
    testimoni: 'The Stone Crusher Management software transformed our dispatch and billing. Weighbridge integration is seamless and reports are spot on.',
    imageUrl: '',
  },
  // ERP Solutions
  {
    id: 2,
    name: 'Sharma Constructions',
    company: 'ERP Solutions Client',
    testimoni: 'Zerlak ERP unified our sales, purchase, inventory and finance. The dashboards helped us spot leakages and improve cash flow.',
    imageUrl: '',
  },
  // Digital Marketing
  {
    id: 3,
    name: 'Sarthak Enterprises',
    company: 'Digital Marketing Client',
    testimoni: 'Within weeks we saw better leads from Google and social. The content plan and reporting are clear and actionable.',
    imageUrl: '',
  },
  // Web Development
  {
    id: 4,
    name: 'InnovativeSoft',
    company: 'Website Project',
    testimoni: 'Our website is fast, modern and easy to manage. The team handled SEO basics and page speed optimizations very well.',
    imageUrl: '',
  },
  // Mobile Development
  {
    id: 5,
    name: 'Kokan Xplore',
    company: 'Mobile App Client',
    testimoni: 'The app is smooth and reliable even offline. Great UX for itinerary planning and local discovery.',
    imageUrl: '',
  },
  // UI/UX Design
  {
    id: 6,
    name: 'CoffeSaaz',
    company: 'UI/UX & Web',
    testimoni: 'Clean design with focus on conversions. The checkout flow and product pages got a measurable lift.',
    imageUrl: '',
  },
  // Hospital Management Product
  {
    id: 7,
    name: 'Sanjeevani Hospital',
    company: 'Hospital Management Client',
    testimoni: 'OPD/IPD processes are much more organized. Pharmacy and lab modules reduced manual reconciliations.',
    imageUrl: '',
  },
  // Study Room Management Product
  {
    id: 8,
    name: 'Focus Study Hub',
    company: 'Study Room Management Client',
    testimoni: 'Seat booking and memberships run on autopilot now. Parents love the attendance and reminders.',
    imageUrl: '',
  },
  // HRM (In Progress)
  {
    id: 9,
    name: 'Prerna Textiles',
    company: 'HRM Pilot',
    testimoni: 'Beta features for attendance and leave are promising. ESS portal is intuitive for staff.',
    imageUrl: '',
  },
  // CRM (In Progress)
  {
    id: 10,
    name: 'Omkar Industries',
    company: 'CRM Pilot',
    testimoni: 'Pipeline and lead tracking already saving time. WhatsApp/email touchpoints make follow-ups easier.',
    imageUrl: '',
  },
];

export const TeamMembers = [
  { name: 'Snehal P', position: 'Sr. Software Developer', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Vishal S', position: 'Development Lead', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Sachin M', position: 'Front End Lead', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Akash S', position: 'Business Analyst', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Swati B', position: 'HR Manager', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Rutuja P', position: 'HR Specialist', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Piyush P', position: 'Data Scientist', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Aniket H', position: 'Graphic Designer', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Riya', position: 'Full Stack Developer Intern', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Rutuja', position: 'Full Stack Developer Intern', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Nirvika', position: 'UI/UX Designer Intern', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Rucha P', position: 'Java Developer Intern', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Venkatensh B', position: 'Java Developer Intern', imageUrl: 'https://zerlak.com/images/about.png' },
  { name: 'Rupesh', position: 'Full Stack Developer Intern', imageUrl: 'https://zerlak.com/images/about1.png' },
  { name: 'Yash W', position: 'UI/UX Designer Intern', imageUrl: 'https://zerlak.com/images/about.png' },
];
